import { useState, useEffect } from 'react';
import { useAlert } from 'components/Alert';
import Icon from 'components/Icon';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { TextKey, CopyToClipBoardContainer, WrapperKey } from './index.view';
import { useTranslation } from 'react-i18next';
import { nameTruncate } from 'utils';

interface CopyToClipBoardProps {
  value: string;
}

const CopyToClipBoard = ({ value }: CopyToClipBoardProps) => {
  const [copied, setCopied] = useState(false);
  const { alert } = useAlert();
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setCopied(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <CopyToClipBoardContainer>
      <CopyToClipboard
        text={value}
        onCopy={() => {
          alert(t('copyToClipboard'));
          setCopied(true);
        }}
      >
        <WrapperKey copied={copied}>
          <TextKey>{nameTruncate(value) || '-'}</TextKey>
          <button>
            <Icon name={copied ? 'copied' : 'copy'} />{' '}
          </button>
        </WrapperKey>
      </CopyToClipboard>
    </CopyToClipBoardContainer>
  );
};

export default CopyToClipBoard;
